export default {
  class_styles: window.class_styles,
  styles: window.myStyles,
  anim: window.anim,
  routes: window.routes,

  current_step_name: null,
  isConfirmOrderLoading: false,

  productTypes: {
    WARRANTY_EXTENSION: 'WE',
    OUT_WARRANTY: 'OW',
    INSURANCE: 'IN',
    ACCESSORY: 'AC'
  },

  productType: window.product_type,

  timer: {
    price_input: null
  },

  is_order_created: false,
  orderId: null
}
